/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listBills = /* GraphQL */ `
  query ListBills {
    listBills {
      id
      totalInEur
    }
  }
`;
